import React, { useCallback } from 'react';
import { slidesComponents, type Slide } from '../../_data';
import { useSlidesContent } from '../../context';
import { isCoverSlide } from '../../utils';
import styles from './styles.module.css';
import { Grid, Typography } from '@mui/material';
import logo from '../../assets/assetmark/logo.png';

type SlideRendererProps = {
  slide: Slide<any>;
  type: 'premium_report' | 'presentation_of_options';
  pageNumber?: number;
};

export const SlideRenderer = React.memo(
  ({ slide, type, pageNumber }: SlideRendererProps): React.ReactElement => {
    const { updateSlideContent } = useSlidesContent();

    const Component = slidesComponents[slide.id];
    // console.log('slide', slide);
    if (!Component) {
      console.log('Component not found for slide', slide.id);
      return <div>Component for slide {slide.id} not found</div>;
    }

    const handleChangeSlide = useCallback(
      (s: Slide<any>, content: any) => updateSlideContent(s, content),
      [updateSlideContent],
    );

    // console.log(`render slide ${slide.id}`);
    return (
      <Grid
        key={slide.slideTemplateId}
        className={
          type === 'premium_report'
            ? ` ${styles.premiumReport} slide-item`
            : `${styles.slide} slide-item`
        }
      >
        <Component slide={slide} onChangeSlide={handleChangeSlide} />
        {!isCoverSlide(slide) && (
          <div className={styles.slideFooter}>
            <div className={styles.slideFooterLeft}>
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontWeight: '400',
                  fontSize: '16px',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  verticalAlign: 'middle',
                  color: '#7D7D7D',
                }}
              >
                For financial advisor use only
              </Typography>
            </div>
            <div className={styles.slideFooterRight}>
              <div className={styles.slideFooterLogo}>
                <img src={logo} alt="logo" />
              </div>
              <div className={styles.slideFooterPageNumber}>
                <Typography
                  sx={{
                    fontFamily: 'Roboto',
                    fontWeight: '700',
                    fontSize: '16px',
                    lineHeight: '100%',
                    letterSpacing: '0%',
                    textAlign: 'right',
                    verticalAlign: 'middle',
                    color: '#7D7D7D',
                    borderLeft: '1px solid #7D7D7D',
                    paddingLeft: '12px',
                  }}
                >
                  {pageNumber ?? 0}
                </Typography>
              </div>
            </div>
          </div>
        )}
      </Grid>
    );
  },
);

export default SlideRenderer;
